if (!customElements.get('wolff-story-row')) {
  customElements.define('wolff-story-row', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.media = this.querySelector('.wolff-story__media');
      if (!this.media || this.dataset.zoom !== 'true') return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.start = Math.min(1, Math.max(.7, Number(this.dataset.startScale) || .88));
      this.inView = true;
      this.schedule = () => {
        if (!this.frame && this.inView) this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', this.schedule, { passive:true, signal });
      window.addEventListener('resize', this.schedule, { passive:true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      this.addEventListener('load', this.schedule, { capture:true, signal });
      this.motion.addEventListener('change', () => this.update(), { signal });
      this.addEventListener('shopify:section:select', this.schedule, { signal });
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.classList.toggle('is-in-view', this.inView && !this.motion.matches);
        this.schedule();
      }, { rootMargin:'200px 0px' });
      this.visibility.observe(this.media);
      this.size = new ResizeObserver(this.schedule);
      this.size.observe(this);
      this.update();
    }

    update() {
      this.frame = null;
      if (!this.isConnected) return;
      if (this.motion.matches || this.start === 1) {
        this.classList.remove('is-zooming', 'is-in-view');
        this.style.removeProperty('--story-scale');
        return;
      }
      const viewport = document.documentElement.clientHeight;
      const rect = this.media.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const progress = Math.min(1, Math.max(0, (viewport * .95 - center) / (viewport * .45)));
      const eased = progress * progress * (3 - 2 * progress);
      this.style.setProperty('--story-scale', (this.start + (1 - this.start) * eased).toFixed(5));
      this.classList.add('is-zooming');
      this.classList.toggle('is-in-view', this.inView);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.visibility?.disconnect();
      this.size?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller = null;
    }
  });
}
